<button
  luiCab
  variant="ghost"
  iconPosition="end"
  luiPreventBubble
  (click)="onToggle()"
  *ngIf="props.canExpand ? props.canExpand(entity) : true"
  class="expand-cell"
>
  {{ props.label | cellLabel : entity }}
  <mat-icon
    svgIcon="chevron_down"
    [class.expanded]="!!this.isExpanded"
    [ariaLabel]="this.isExpanded ? 'collapse' : 'expand'"
    i18n-aria-label
  ></mat-icon>
</button>
